import type { Copy } from './types';

export const es: Copy = {
  nav: {
    about: 'Sobre nosotros',
    apiPlatform: 'Plataforma API',
    login: 'Acceder',
    cta: 'Habla con nosotros',
  },
  hero: {
    title: 'be the jungle.',
    subA: 'La única plataforma inteligente que lo conecta todo.',
    subB: 'El sistema definitivo para operar tu agencia.',
    cta: 'Empieza hoy',
  },
  aboutHero: {
    title: 'Construyendo la jungla\ndel viaje del futuro',
    subA: 'Somos un equipo apasionado por transformar la distribución de viajes a través de tecnología y datos.',
    subB: 'Nuestra misión: que las agencias ganen.',
    cta: 'Habla con nosotros',
  },
  apiPlatformHero: {
    title: 'One Connection.\nInfinite Opportunities.',
    subA: 'Conecta con proveedores y distribuidores globales a través de un hub potente — crece más rápido, vende con inteligencia y simplifica tu negocio de viajes.',
    subB: 'Suite de APIs de viajes para equipos enterprise.',
    cta: 'Solicitar acceso',
    docsCta: 'Ver documentación API',
    microLine: 'API-first · Documentación completa · Sandbox incluido',
  },
  sector: {
    eyebrow: 'THE TRAVEL JUNGLE',
    title: 'Nuestro sector es cada vez más salvaje',
    lead: 'Decenas de proveedores, sistemas fragmentados, precios que cambian constantemente, prisas, imprecisiones y las Agencias tratando de sobrevivir en un ecosistema complejo para encontrar las mejores opciones para sus clientes.',
  },
  sobrevivir: {
    eyebrow: 'LA INFRAESTRUCTURA QUE LO CONECTA TODO',
    titleA: 'Deja de sobrevivir.',
    titleB: 'Be the jungle.',
    lead: 'Una única plataforma inteligente que unifica tus proveedores, automatiza tus propuestas y maximiza tus ventas. Multiproveedor, multiproducto, multidestino.',
  },
  adapta: {
    eyebrow: 'SIN CAMBIAR TU ECOSISTEMA DE PROVEEDORES',
    titleA: 'Bundleport se adapta',
    titleB: 'a ti, no al revés',
    lead: 'Empieza en días, no en meses. Nuestro onboarding guiado te conecta con tus proveedores actuales y te ayuda a ampliar inventario sin coste adicional.',
  },
  proveedores: {
    eyebrow: 'ALL SPECIES. ONE ECOSYSTEM.',
    titleA: 'Todos tus proveedores,',
    titleB: 'en un solo lugar',
  },
  creces: {
    eyebrow: 'PRICING',
    titleA: 'Tú creces,',
    titleB: 'nosotros crecemos',
    lead: 'Un modelo de negocio alineado con el tuyo.\nSin letra pequeña, sin permanencia mínima.',
    cta: 'Contactar con ventas',
  },
  contacto: {
    eyebrow: 'CONTACTO',
    titleA: 'Deja de sobrevivir.',
    titleB: 'Be the jungle.',
    formTitle: 'Solicita tu demo',
    sideTitle: 'Hablemos de tu agencia',
    sideLead:
      'Cuéntanos cómo trabajas hoy y te mostramos cómo puedes vender más, gestionar menos y mejorar tu margen. Sin compromiso.',
    submit: 'Solicitar demo',
    sending: 'Enviando…',
    sent: '¡Enviado! Gracias',
    errorMsg: 'Error. Inténtalo de nuevo.',
    consent:
      'Acepto la <a href="/privacy-policy" target="_blank" rel="noopener">Política de privacidad</a> y que Bundleport use mis datos para contactarme sobre esta solicitud y productos relacionados.',
    consentError: 'Debes aceptar la política de privacidad para continuar.',
    motorLabel: '¿Trabajas con un motor de reservas propio o usas una solución externa?',
    motorOwn: 'Propio',
    motorExternal: 'Externo',
    motorWhich: '¿Cuál?',
    motorWhichPh: 'Nombre del motor o solución',
    forLabel: 'Pensado para',
  },
  aboutPage: {
    missionLabel: 'Nuestra misión',
    missionTitle: 'Devolverle el poder<br />a las agencias de viajes',
    missionP1:
      'El sector viajes avanza a gran velocidad. Los agentes necesitan tecnología que les libere de la operativa compleja y les permita centrarse en lo que de verdad importa: crear experiencias de viaje memorables.',
    missionP2:
      'Creemos que las agencias de viajes tienen un valor insustituible: la confianza, el conocimiento y la relación personal con el viajero. Nuestra tecnología amplifica ese valor, no lo sustituye.',
    missionP3:
      'Somos una plataforma de distribución AI-native que unifica proveedores, automatiza procesos y equipa a las agencias con las herramientas para operar con eficiencia, escalar sin fricciones y diferenciarse en el mercado.',
    missionTagline: 'All Species. One Ecosystem',
    valuesLabel: 'Nuestros valores',
    valuesTitle: 'Lo que nos guía cada día',
    values: [
      {
        icon: '🤝',
        title: 'Be a Partner',
        desc: 'Crecemos más fuertes juntos. Construimos relaciones transparentes y beneficiosas que generan valor duradero para todos los que forman parte del ecosistema.',
      },
      {
        icon: '🔒',
        title: 'Be Reliable',
        desc: 'Cumplimos lo que prometemos. Ofrecemos soluciones seguras, consistentes y escalables para que nuestros socios puedan contar con nosotros en cada paso del camino.',
      },
      {
        icon: '🌱',
        title: 'Be a Good Persona',
        desc: 'Creemos en hacer el bien mientras hacemos negocio. Actuamos con integridad, empatía y respeto en cada interacción, dentro y fuera de la empresa.',
      },
      {
        icon: '⚡',
        title: 'Be Empowering',
        desc: 'Ayudamos a los demás a brillar. Ponemos a nuestros socios en control, dándoles claridad, confianza y las herramientas para tener éxito.',
      },
      {
        icon: '🚀',
        title: 'Be Innovative with Purpose',
        desc: 'Resolvemos problemas reales con creatividad. Construimos soluciones que simplifican, conectan y empoderan, no solo tecnología por el bien de la tecnología.',
      },
    ],
    commitmentLabel: 'Nuestro compromiso',
    commitmentText:
      'Cada día trabajamos para vivir estos valores y crear un ecosistema de tecnología de viajes donde las alianzas florezcan, la innovación prospere y todos tengan las herramientas que necesitan para triunfar. No solo construimos tecnología, construimos relaciones y empoderamos el futuro del viaje.',
    ctaTitle: '¿Listo para<br />unirte a la jungla?',
    ctaSub: 'Habla con nuestro equipo y descubre cómo Bundleport puede transformar tu agencia.',
  },
  apiPlatformPage: {
    whyBpLabel: 'Por qué Bundleport',
    whyBpTitle: 'Travel tech moderna, sin lastre legacy',
    whyBpItem1:
      'Un stack <strong>AI-native</strong> y multiproducto frente a integraciones legacy punto a punto.',
    whyBpItem2:
      '<strong>Una sola API</strong> frente a decenas de conexiones frágiles a proveedores.',
    whyBpItem3:
      '<strong>Sandbox y documentación</strong> pensados para equipos que quieren velocidad real de despliegue.',
    perfectForLabel: 'Diseñado para',
    perfectForTitle: 'Empresas que exigen control total y flexibilidad',
    perfectForDesc:
      'Bundleport Connect está pensado para equipos tech que quieren integrar viajes sin fricción.',
    audiences: [
      {
        icon: '🚀',
        title: 'Tech Startups',
        desc: 'Construye experiencias de viaje innovadoras con APIs flexibles y despliegue rápido. Lanza en días, no en meses.',
      },
      {
        icon: '🏢',
        title: 'Enterprise Travel',
        desc: 'Integra capacidades de viaje en tus plataformas existentes con fiabilidad de nivel empresarial y SLA garantizado.',
      },
      {
        icon: '🔗',
        title: 'System Integrators',
        desc: 'Conecta múltiples sistemas sin esfuerzo gracias a documentación exhaustiva y soporte dedicado.',
      },
    ],
    whyLabel: 'Por qué Bundleport Connect',
    whyTitle: 'Una conexión.<br />Todo el inventario global.',
    whyDesc:
      'El sector viajes no necesita más complejidad — necesita claridad. Sustituye múltiples integraciones por un hub que lo hace todo.',
    features: [
      {
        icon: '🌐',
        title: 'Inventario global unificado',
        desc: 'Vuelos, hoteles, experiencias y trenes a través de una sola API segura. Sin contratos separados por proveedor.',
      },
      {
        icon: '⚡',
        title: 'Datos en tiempo real',
        desc: 'Precios, disponibilidad y reservas en vivo con tiempos de respuesta <500ms. Nunca datos desactualizados.',
      },
      {
        icon: '🛠️',
        title: 'Integración modular y flexible',
        desc: 'Conéctate a tu CRM, CMS o back-office con módulos plug-and-play. Adapta lo que necesitas.',
      },
      {
        icon: '📄',
        title: 'Entorno developer-ready',
        desc: 'Documentación rica, sandbox de pruebas y quick-start templates para builds más rápidos.',
      },
      {
        icon: '🛡️',
        title: 'Fiabilidad enterprise',
        desc: 'Uptime garantizado por SLA, monitorización proactiva y soporte técnico dedicado para operaciones críticas.',
      },
    ],
    whyCardLabel: 'Resultados reales',
    whyCardTitle: 'La plataforma que elimina la complejidad técnica del sector viajes',
    stats: [
      { value: '+20', label: 'Proveedores certificados integrados' },
      { value: '<500ms', label: 'Tiempo de respuesta garantizado' },
      { value: '99.9%', label: 'Uptime SLA garantizado' },
      { value: '1 API', label: 'Para todo el inventario' },
    ],
    supplyLabel: 'Beneficios directos',
    supplyTitle: 'Más inventario.<br />Menos trabajo.',
    supplyDesc:
      'Para agencias, OTAs y distribuidores listos para escalar su oferta sin complicaciones técnicas.',
    benefits: [
      {
        icon: '📦',
        title: 'Inventario masivo, una sola API',
        desc: 'Vuelos, hoteles, trenes, tours, actividades y transfers — todo disponible de golpe. Sin negociar cada proveedor.',
      },
      {
        icon: '🚀',
        title: 'Lanza en días, no en meses',
        desc: 'Nuevos destinos y productos disponibles en tu plataforma en cuestión de días. Velocidad competitiva real.',
      },
      {
        icon: '💰',
        title: 'Menos costes, más margen',
        desc: 'Reduce el gasto en integraciones y destina ese presupuesto a crecer. Una conexión sustituye a docenas.',
      },
      {
        icon: '📊',
        title: 'Insights accionables',
        desc: 'Monitoriza rendimiento, tendencias de demanda y fiabilidad de proveedores en tiempo real. Decisiones con datos.',
      },
    ],
    providersLabel: 'Ecosistema conectado',
    providersTitle: 'All Species. One Ecosystem',
    providersDesc:
      'Accede al inventario de los principales proveedores globales a través de una sola integración.',
    providersNote: 'Y seguimos creciendo. Nuevos proveedores se integran constantemente.',
    howLabel: 'Simple y rápido',
    howTitle: 'Tres pasos para transformar<br />tu negocio de viajes',
    howDesc: 'Conecta una vez y accede a todo. Sin complejidad técnica innecesaria.',
    steps: [
      {
        num: '1',
        title: 'Conecta',
        desc: 'Una sola integración con Bundleport Connect te da acceso a todo el ecosistema de proveedores y distribuidores globales.',
      },
      {
        num: '2',
        title: 'Selecciona',
        desc: 'Elige los proveedores o distribuidores que encajan con tu modelo de negocio. Define reglas de precio, visibilidad y márgenes.',
      },
      {
        num: '3',
        title: 'Escala',
        desc: 'Empieza a vender y a crecer de inmediato. Añade nuevos proveedores o mercados cuando quieras, sin rediseñar tu arquitectura.',
      },
    ],
    ctaTitle: 'Empieza a construir hoy.<br />El futuro del viaje te espera.',
    ctaSub:
      'Únete a los equipos que están construyendo el futuro de los viajes con Bundleport Connect.',
    ctaBtn1: 'Solicitar acceso',
    ctaBtn2: 'Ver documentación API',
    ctaMicro: 'Sandbox gratuito · Documentación completa',
    contactLabel: 'Contacto',
    contactTitle: 'Hablemos de tu integración',
    contactDesc:
      'Cuéntanos tu caso de uso y te mostramos cómo Bundleport Connect puede acelerar tu desarrollo. Sin compromiso.',
  },
  privacyPage: {
    title: 'Política de privacidad',
    meta: 'Última actualización: 6 de marzo de 2026 · Bundleport',
    toc: 'Contenido',
    intro:
      'En Bundleport tratamos tu información con transparencia y responsabilidad. Esta política explica qué datos recopilamos, cómo los usamos y cómo los protegemos.',
    sections: [
      {
        id: 'data-collected',
        num: '1',
        title: 'Información que recopilamos',
        body: '<p>Recopilamos los siguientes tipos de información cuando utilizas nuestros servicios:</p><ul><li><strong>Información de cuenta:</strong> nombre, dirección de correo electrónico y nombre de empresa y datos de contacto.</li><li><strong>Datos de uso de la API y registros:</strong> endpoints invocados, metadatos de solicitudes y respuestas, tasas de error.</li><li><strong>Preferencias de comunicación:</strong> configuración de marketing y notificaciones.</li><li><strong>Información técnica:</strong> direcciones IP, tipo de navegador, sistema operativo e identificadores de sesión.</li></ul>',
      },
      {
        id: 'how-we-use',
        num: '2',
        title: 'Cómo usamos tu información',
        body: '<p>Utilizamos la información recopilada para los siguientes fines:</p><ul><li>Procesar solicitudes de API y prestar el Servicio.</li><li>Supervisar el rendimiento de la plataforma y mejorar su fiabilidad.</li><li>Proporcionar soporte al cliente y responder a consultas.</li><li>Enviar actualizaciones del producto, avisos de seguridad y comunicaciones promocionales (con consentimiento).</li><li>Responder a solicitudes de soporte y otras consultas.</li></ul>',
      },
      {
        id: 'security',
        num: '3',
        title: 'Seguridad de los datos',
        body: '<p>Protegemos tu información mediante cifrado de extremo a extremo, auditorías de seguridad periódicas, controles de acceso estrictos y centros de datos seguros. Nuestro equipo sigue las mejores prácticas del sector para salvaguardar tus datos.</p>',
      },
      {
        id: 'sharing',
        num: '4',
        title: 'Compartición de datos',
        body: '<p>No vendemos, intercambiamos ni alquilamos tu información personal a terceros. Las transferencias de datos se realizan únicamente según se describe en esta Política de Privacidad y de conformidad con la legislación aplicable.</p>',
      },
    ],
    rightsTitle: 'Tus derechos',
    rightsIntro:
      'Tienes derecho a gestionar tus datos personales. Puedes ejercer los siguientes derechos contactándonos a través de nuestros canales de soporte:',
    rights: [
      {
        title: '🔍 Acceso',
        desc: 'Solicitar una copia de los datos personales que conservamos sobre ti.',
      },
      { title: '✏️ Corrección', desc: 'Solicitar la corrección de datos inexactos o incompletos.' },
      {
        title: '🗑️ Eliminación',
        desc: 'Solicitar la eliminación de tus datos personales cuando proceda.',
      },
      {
        title: '📦 Portabilidad',
        desc: 'Recibir tus datos en un formato estructurado y legible por máquina.',
      },
    ],
    contactTitle: 'Contacto',
    contactBody:
      'Si tienes alguna pregunta sobre esta Política de Privacidad o deseas ejercer tus derechos, contacta con nosotros a través de nuestros canales de soporte.',
  },
  termsPage: {
    title: 'Términos de servicio',
    meta: 'Última actualización: 6 de marzo de 2026 · Bundleport',
    toc: 'Contenido',
    intro:
      'Al acceder o utilizar la plataforma Bundleport, aceptas quedar vinculado por estos Términos de Servicio. Estos Términos constituyen un acuerdo legalmente vinculante entre tú y Bundleport.',
    sections: [
      {
        id: 'acceptance',
        num: '1',
        title: 'Aceptación de términos',
        body: '<p>Al acceder o utilizar la plataforma Bundleport, aceptas quedar vinculado por estos Términos de Servicio. Estos Términos constituyen un acuerdo legalmente vinculante entre tú y Bundleport. Si utilizas el Servicio en nombre de una organización, declaras y garantizas que tienes autoridad para vincular a dicha organización a estos Términos.</p>',
      },
      {
        id: 'definitions',
        num: '2',
        title: 'Definiciones',
        body: '<p>En estos Términos, los siguientes términos tienen el significado indicado:</p><ul><li><strong>"Servicio"</strong> designa la plataforma Bundleport, la API, el dashboard y todas las herramientas relacionadas.</li><li><strong>"Usuario"</strong> designa cualquier persona física o jurídica que accede o utiliza el Servicio.</li><li><strong>"Contenido"</strong> designa los datos, información y materiales procesados a través del Servicio.</li><li><strong>"API"</strong> designa la interfaz de programación de aplicaciones Bundleport Connect.</li><li><strong>"Proveedor"</strong> designa cualquier proveedor externo de contenido o inventario de viajes integrado en el Servicio.</li></ul>',
      },
      {
        id: 'license',
        num: '3',
        title: 'Licencia y uso de materiales',
        body: '<h3>3.1 Licencia limitada</h3><p>Te otorgamos una licencia limitada, no exclusiva, intransferible y revocable para acceder y utilizar el Servicio exclusivamente para tus fines comerciales internos en el sector de distribución de viajes.</p><h3>3.2 Actos prohibidos</h3><p>No podrás: (a) realizar ingeniería inversa, descompilar o desensamblar el Servicio; (b) sublicenciar, vender o redistribuir el acceso al Servicio sin autorización escrita; (c) extraer datos más allá del uso permitido de la API; (d) eliminar o modificar avisos de propiedad; (e) utilizar el Servicio para fines ilícitos.</p>',
      },
      {
        id: 'obligations',
        num: '4',
        title: 'Obligaciones del usuario y uso aceptable',
        body: '<h3>4.1 Obligaciones</h3><p>Te comprometes a: proporcionar información de cuenta veraz y completa; mantener la seguridad de tus credenciales y claves de API; cumplir con toda la normativa aplicable; notificarnos sin demora cualquier brecha de seguridad.</p><h3>4.2 Uso indebido</h3><p>No debes utilizar el Servicio para: eludir límites de uso o restricciones técnicas; interferir en el funcionamiento del Servicio o perturbarlo; acceder a la cuenta de otro usuario sin autorización; procesar reservas o transacciones fraudulentas.</p>',
      },
      {
        id: 'api',
        num: '5',
        title: 'Uso de la API; límites de uso; integración',
        body: '<p>El acceso a la API Bundleport Connect está sujeto a los límites de uso especificados en tu plan de suscripción. Superar dichos límites puede dar lugar a una limitación temporal o suspensión del acceso. Debes utilizar la API de conformidad con nuestra documentación.</p><p>Los datos de disponibilidad y precios almacenados en caché no pueden conservarse más de 24 horas sin autorización expresa por escrito.</p>',
      },
      {
        id: 'availability',
        num: '6',
        title: 'Disponibilidad del servicio; mantenimiento',
        body: '<p>Bundleport se compromete a alcanzar una disponibilidad de la plataforma del 99,9 %, excluidos los mantenimientos programados. Procuraremos avisar con antelación de los mantenimientos planificados.</p><p>No garantizamos la disponibilidad del contenido de proveedores externos, que depende de los propios sistemas y políticas de cada proveedor.</p>',
      },
      {
        id: 'payments',
        num: '7',
        title: 'Pagos y facturación',
        body: '<p>Las tarifas se establecen en tu acuerdo comercial con Bundleport. Salvo pacto en contrario, las facturas se emiten mensual o anualmente en euros. Los retrasos en el pago pueden dar lugar a la suspensión del acceso tras un período de gracia de 15 días.</p><p>Los precios están sujetos a cambios con un preaviso por escrito de 30 días. Todos los importes se indican sin los impuestos aplicables.</p>',
      },
      {
        id: 'data-protection',
        num: '8',
        title: 'Protección de datos y privacidad',
        body: '<p>Ambas partes se comprometen a cumplir la normativa aplicable en materia de protección de datos. Bundleport trata los datos personales de conformidad con su Política de Privacidad. Cuando Bundleport trate datos personales de viajeros en tu nombre, actuará como encargado del tratamiento en el marco de un Acuerdo de Tratamiento de Datos.</p><p>Eres responsable de obtener todos los consentimientos necesarios de los viajeros cuyos datos envíes al Servicio.</p>',
      },
      {
        id: 'third-party',
        num: '9',
        title: 'Contenido de terceros; servicios de proveedores',
        body: '<p>El Servicio agrega inventario, precios y contenidos procedentes de proveedores externos. Bundleport no garantiza la exactitud, integridad ni disponibilidad del contenido de dichos proveedores.</p><p>Las reservas realizadas a través del Servicio se rigen por los términos y condiciones de cada proveedor, que prevalecen sobre estos Términos en lo que respecta al propio servicio de viaje.</p>',
      },
      {
        id: 'warranties',
        num: '10',
        title: 'Garantías y exenciones de responsabilidad',
        body: '<p>El Servicio se presta "tal cual" y "según disponibilidad". En la medida máxima permitida por la ley, Bundleport renuncia a toda garantía, expresa o implícita, incluidas las garantías de comercialización, adecuación para un fin particular y no infracción.</p><p>No garantizamos que el Servicio sea ininterrumpido, esté libre de errores ni exento de componentes dañinos.</p>',
      },
      {
        id: 'liability',
        num: '11',
        title: 'Limitación de responsabilidad',
        body: '<p>En la medida máxima permitida por la ley aplicable, la responsabilidad total acumulada de Bundleport ante ti por cualquier reclamación derivada de estos Términos o relacionada con ellos no excederá del importe mayor entre: (a) las tarifas totales abonadas por ti a Bundleport en los doce (12) meses anteriores a la reclamación, o (b) 100 €.</p><p>En ningún caso Bundleport será responsable de daños indirectos, incidentales, consecuentes o punitivos, incluida la pérdida de beneficios, datos o fondo de comercio.</p>',
      },
      {
        id: 'indemnification',
        num: '12',
        title: 'Indemnización',
        body: '<p>Aceptas indemnizar, defender y eximir de responsabilidad a Bundleport, sus filiales, directivos y empleados frente a cualquier reclamación, responsabilidad, daño y gasto (incluidos honorarios legales razonables) que surjan de: (a) tu uso del Servicio; (b) el incumplimiento de estos Términos; (c) la vulneración de derechos de terceros; o (d) cualquier contenido que envíes al Servicio.</p>',
      },
      {
        id: 'termination',
        num: '13',
        title: 'Resolución y suspensión',
        body: '<p>Cualquiera de las partes podrá resolver este acuerdo mediante notificación escrita. Bundleport podrá suspender o resolver tu acceso de forma inmediata si incumples estos Términos, realizas actividades fraudulentas o si tu cuenta supone un riesgo para el Servicio u otros usuarios.</p><p>Tras la resolución, todas las licencias concedidas en virtud del presente acuerdo cesarán de forma inmediata.</p>',
      },
      {
        id: 'changes',
        num: '14',
        title: 'Cambios en los términos',
        body: '<p>Bundleport se reserva el derecho de modificar estos Términos en cualquier momento. Los cambios materiales se comunicarán con al menos 30 días de antelación mediante correo electrónico o notificación en la plataforma. El uso continuado del Servicio tras la fecha de entrada en vigor de cualquier cambio implica la aceptación de los Términos actualizados.</p>',
      },
      {
        id: 'law',
        num: '15',
        title: 'Ley aplicable y resolución de conflictos',
        body: '<p>Estos Términos se rigen por la legislación española. Cualquier controversia que surja en relación con estos Términos se someterá a la jurisdicción exclusiva de los tribunales de Madrid, España, con renuncia expresa de ambas partes a cualquier otro fuero que pudiera corresponder.</p>',
      },
      {
        id: 'misc',
        num: '16',
        title: 'Disposiciones generales',
        body: '<p>Si alguna disposición de estos Términos se declara inválida o inaplicable, las restantes disposiciones permanecerán en plena vigencia. Estos Términos constituyen el acuerdo íntegro entre las partes en relación con el Servicio.</p><p>El hecho de no ejercer un derecho o disposición no constituirá una renuncia al mismo. No podrás ceder tus derechos en virtud de estos Términos sin nuestro consentimiento previo por escrito.</p>',
      },
    ],
  },
};
